import { Stack, Box, Avatar, IconButton, Typography } from "@mui/material";
import FormProvider from "../../../components/hook-form/FormProvider";
import { useForm } from "react-hook-form";
import { RHFTextField } from "../../../components/hook-form";
import { useState } from "react";
import Iconify from "../../../components/iconify";

import { getR2File } from "../../../utils/file";

export default function PatientInfo(props: any) {
  const { patientInfo } = props;
  const [showImage, setShowImage] = useState(true);

  const methods = useForm({
    defaultValues: {
      firstName: patientInfo?.firstName,
      surName: patientInfo?.surName,
      postCode: patientInfo?.postCode,
      email: patientInfo?.email,
      gp: patientInfo?.gp,
    },
  });

  return (
    <FormProvider methods={methods}>
      <Stack spacing={3} sx={{ px: 3, mt: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={() => setShowImage(!showImage)}>
            <Iconify icon={showImage ? "eva:eye-fill" : "eva:eye-off-fill"} />
          </IconButton>
          <Typography variant="subtitle2">
            {showImage ? "Hide Photo" : "Show Photo"}
          </Typography>
        </Box>

        {showImage && (
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2, flexDirection: "column", alignItems: "center" }}>
            <Avatar
              src={getR2File(patientInfo?.imageUrl) as string}
              alt={patientInfo?.firstName}
              sx={{ width: 150, height: 150, mb: 1 }}
              imgProps={{ referrerPolicy: "no-referrer" }}
            />
          </Box>
        )}

        <Box sx={{ display: "flex" }}>
          <RHFTextField
            error={false}
            name="firstName"
            label="First Name"
            sx={{ mt: "20px", width: "50%" }}
            disabled
          />
          <RHFTextField
            error={false}
            name="surName"
            label="Surname"
            sx={{ mt: "20px", ml: "15px", width: "50%" }}
            disabled
          />
        </Box>

        <Box sx={{ display: "flex" }}>
          <RHFTextField
            error={false}
            name="postCode"
            label="Post Code"
            disabled
            sx={{ width: "50%" }}
          />
          <RHFTextField
            error={false}
            name="email"
            label="Email"
            disabled
            sx={{ ml: "15px", width: "50%" }}
          />
        </Box>
        {patientInfo?.gp && (
          <Box sx={{ display: "flex" }}>
            <RHFTextField
              error={false}
              name="gp"
              label="GP"
              disabled
              sx={{ width: "100%" }}
            />
          </Box>
        )}
      </Stack>
    </FormProvider>
  );
}
